// extracted by mini-css-extract-plugin
export default {"button-wrapper":"_1DwAZ","buttonWrapper":"_1DwAZ","folder-description":"_2bXUK","folderDescription":"_2bXUK"};